import { useColorMode } from "@chakra-ui/react";
import colors from "./foundations/colors";
import semanticTokens from "./semanticTokens";
import { tint } from "./tint";

// O recharts pinta o SVG por atributos (fill/stroke), que não enxergam os tokens do Chakra
// (CSS vars); aqui o token semântico vira a cor final do modo atual.
function resolve(name, colorMode) {
  const value = semanticTokens.colors[name][colorMode === "dark" ? "_dark" : "default"];
  const [scale, shade] = value.split(".");
  return colors[scale]?.[shade] ?? value;
}

export function useChartColors() {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";
  return {
    grid: resolve("app-muted", colorMode),
    axis: resolve("app-muted-fg", colorMode),
    text: resolve("app-fg", colorMode),
    surface: resolve("app-card", colorMode),
    border: resolve("app-border", colorMode),
    bar: resolve("primary", colorMode),
    // Texto da série no tooltip: a cor da barra no escuro não passa AA como texto.
    barText: resolve("accent-text", colorMode),
    cursor: isDark ? tint(colors.brand[300], 0.1) : tint(colors.brand[500], 0.06),
  };
}
